// removed by extract-text-webpack-plugin
module.exports = {"LockRemover":"LockRemover__2M132"};